/*
 *
 * Summary constants
 *
 */
export const BASE_ACTION_CONSTANT = `app/Summary`;

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;
export const GET_SUMMARY_DATA = `${BASE_ACTION_CONSTANT}/GET_SUMMARY_DATA`;
export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;
export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const GET_RECENT_SETTLEMENTS = `${BASE_ACTION_CONSTANT}/GET_RECENT_SETTLEMENTS`;
export const GET_DISPUTES_COUNT = `${BASE_ACTION_CONSTANT}/GET_DISPUTES_COUNT`;
export const GET_SUSPICIOUS_TRANSACTIONS = `${BASE_ACTION_CONSTANT}/GET_SUSPICIOUS_TRANSACTIONS`;
export const GET_TRANSACTION_SUMMARY = `${BASE_ACTION_CONSTANT}/GET_TRANSACTION_SUMMARY`;
export const GET_TRANSACTION_CURRENCY_SUMMARY = `${BASE_ACTION_CONSTANT}/GET_TRANSACTION_CURRENCY_SUMMARY`;
export const GET_REFUNDS_SUMMARY = `${BASE_ACTION_CONSTANT}/GET_REFUNDS_SUMMARY`;
export const GET_PAYMENT_METHODS_SUMMARY = `${BASE_ACTION_CONSTANT}/GET_PAYMENT_METHODS_SUMMARY`;
export const GET_AVERAGE_TRANSACTION_SUMMARY = `${BASE_ACTION_CONSTANT}/GET_AVERAGE_TRANSACTION_SUMMARY`;
export const GET_AVERAGE_TRANSACTION_CURRENCY_SUMMARY = `${BASE_ACTION_CONSTANT}/GET_AVERAGE_TRANSACTION_CURRENCY_SUMMARY`;
export const GET_UNSETTLED_AMOUNT_SUMMARY = `${BASE_ACTION_CONSTANT}/GET_UNSETTLED_AMOUNT_SUMMARY`;
export const GET_RECHARGE_BANK_DETAILS = `${BASE_ACTION_CONSTANT}/GET_RECHARGE_BANK_DETAILS`;
export const GET_SETTLEMENT_HOLIDAYS_DETAILS = `${BASE_ACTION_CONSTANT}/GET_SETTLEMENT_HOLIDAYS_DETAILS`;

export const UPDATE_RECENT_SETTLEMENTS = `${BASE_ACTION_CONSTANT}/UPDATE_RECENT_SETTLEMENTS`;
export const UPDATE_DISPUTES_COUNT = `${BASE_ACTION_CONSTANT}/UPDATE_DISPUTES_COUNT`;
export const UPDATE_SUSPICIOUS_TRANSACTIONS = `${BASE_ACTION_CONSTANT}/UPDATE_SUSPICIOUS_TRANSACTIONS`;
export const UPDATE_TRANSACTION_SUMMARY = `${BASE_ACTION_CONSTANT}/UPDATE_TRANSACTION_SUMMARY`;
export const UPDATE_TRANSACTION_CURRENCY_SUMMARY = `${BASE_ACTION_CONSTANT}/UPDATE_TRANSACTION_CURRENCY_SUMMARY`;
export const UPDATE_REFUNDS_SUMMARY = `${BASE_ACTION_CONSTANT}/UPDATE_REFUNDS_SUMMARY`;
export const UPDATE_PAYMENT_METHODS_SUMMARY = `${BASE_ACTION_CONSTANT}/UPDATE_PAYMENT_METHODS_SUMMARY`;
export const UPDATE_AVERAGE_TRANSACTION_SUMMARY = `${BASE_ACTION_CONSTANT}/UPDATE_AVERAGE_TRANSACTION_SUMMARY`;
export const UPDATE_AVERAGE_TRANSACTION_CURRENCY_SUMMARY = `${BASE_ACTION_CONSTANT}/UPDATE_AVERAGE_TRANSACTION_CURRENCY_SUMMARY`;
export const UPDATE_UNSETTLED_AMOUNT_SUMMARY = `${BASE_ACTION_CONSTANT}/UPDATE_UNSETTLED_AMOUNT_SUMMARY`;
export const UPDATE_RECHARGE_BANK_DETAILS = `${BASE_ACTION_CONSTANT}/UPDATE_RECHARGE_BANK_DETAILS`;
export const UPDATE_SETTLEMENT_HOLIDAYS_DETAILS = `${BASE_ACTION_CONSTANT}/UPDATE_SETTLEMENT_HOLIDAYS_DETAILS`;
export const GET_MERCHANT_CREDITS = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_CREDITS`;
export const UPDATE_MERCHANT_CREDITS = `${BASE_ACTION_CONSTANT}/UPDATE_MERCHANT_CREDITS`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;
export const UPDATE_ALERT_BAR_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_ALERT_BAR_DATA`;

export const GET_UNIFICATION_ONBOARDING = `${BASE_ACTION_CONSTANT}/GET_UNIFICATION_ONBOARDING`;

export const GET_MERCHANT_CHECKLIST_PREFERENCE = `${BASE_ACTION_CONSTANT}/GET_MERCHANT_CHECKLIST_PREFERENCE`;

export const DISMISS_MERCHANT_QUESTIONNAIRE = `${BASE_ACTION_CONSTANT}/DISMISS_MERCHANT_QUESTIONNAIRE`;

export const POST_MERCHANT_QUESTIONNAIRE_RESPONSE = `${BASE_ACTION_CONSTANT}/POST_MERCHANT_QUESTIONNAIRE_RESPONSE`;

export const SET_MERCHANT_CHECKLIST_SOURCE_LIST = `${BASE_ACTION_CONSTANT}/SET_MERCHANT_CHECKLIST_SOURCE_LIST`;

export const GET_FREE_TRIAL_STATUS = `${BASE_ACTION_CONSTANT}/GET_FREE_TRIAL_STATUS`;

export const GET_FREE_TRIAL_NUDGE = `${BASE_ACTION_CONSTANT}/GET_FREE_TRIAL_NUDGE`;

export const UPDATE_OFFLINE_RECENT_SETTLEMENT_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_OFFLINE_RECENT_SETTLEMENT_DATA`;

export const GET_RISKSHIELD_ACTIVE_STATUS = `${BASE_ACTION_CONSTANT}/GET_RISKSHIELD_ACTIVE_STATUS`;

export const SET_RISKSHIELD_ACTIVE_STATUS = `${BASE_ACTION_CONSTANT}/SET_RISKSHIELD_ACTIVE_STATUS`;

export const GET_LIFETIME_GMV = `${BASE_ACTION_CONSTANT}/GET_LIFETIME_GMV`;

export const SET_RISKSHIELD_DATA = `${BASE_ACTION_CONSTANT}/SET_RISKSHIELD_DATA`;

export const GET_RISKSHIELD_DATA = `${BASE_ACTION_CONSTANT}/GET_RISKSHIELD_DATA`;

export const SET_LIFETIME_GMV = `${BASE_ACTION_CONSTANT}/SET_LIFETIME_GMV`;

export const RISKY_TRANSACTIONS_PATH = 'pg/risk-shield/risky-transactions/';

export const GET_RECENT_SETTLEMENTS_URL = {
  url: '/pg/summary/recent-settlements',
  method: 'GET',
};

export const GET_DISPUTES_COUNT_URL = {
  url: '/pg/disputes/summary',
  method: 'GET',
};

export const GET_SUSPICIOUS_TRANSACTIONS_URL = {
  url: '/pg/summary/risk-transactions',
  method: 'GET',
};

export const GET_TRANSACTION_SUMMARY_URL = {
  url: '/pg/summary/transactions',
  method: 'GET',
};

export const GET_TRANSACTION_CURRENCY_SUMMARY_URL = {
  url: '/pg/summary/transactions-by-currency',
  method: 'GET',
};

export const GET_REFUNDS_SUMMARY_URL = {
  url: '/pg/summary/refunds-by-currency',
  method: 'GET',
};

export const GET_PAYMENT_METHODS_SUMMARY_URL = {
  url: '/pg/summary/payment-methods',
  method: 'GET',
};

export const GET_AVERAGE_TRANSACTION_SUMMARY_URL = {
  url: '/pg/summary/average-transactions',
  method: 'GET',
};

export const GET_AVERAGE_TRANSACTION_CURRENCY_SUMMARY_URL = {
  url: '/pg/summary/average-transactions-by-currency',
  method: 'GET',
};

export const GET_RISKSHIELD_ACTIVE_STATUS_URL = {
  url: '/merchant/v1/risk-platform/product/PG/status',
  method: 'GET',
};

export const GET_RISKSHIELD_DATA_URL = {
  url: '/merchant/v1/risk-platform/pgdb/agg/flagged-txns',
  method: 'GET',
};

export const GET_LIFETIME_GMV_URL = {
  url: '/merchant/v1/risk-platform/merchant/metadata',
  method: 'GET',
};

export const PAYLOAD_MAPPER_OBJ = {
  AVERAGE_TRANSACTION: 'averageTransactionSummaryData',
  REFUNDS: 'refundsSummaryData',
  TRANSACTIONS: 'transactionSummaryData',
  TRANSACTION_CURRENCY: 'transactionCurrencySummaryData',
  AVERAGE_TRANSACTION_CURRENCY: 'averageTransactionCurrencySummaryData',
};

export const SETTLEMENTS = 'SETTLEMENTS';

export const PAYMENT_VERIFICATION = 'PAYMENT_VERIFICATION';

export const DISPUTES = 'DISPUTES';

export const SUSPICIOUS = 'SUSPICIOUS';

export const TRANSACTIONS = 'TRANSACTIONS';

export const TRANSACTION_CURRENCY = 'TRANSACTION_CURRENCY';

export const AVERAGE_TRANSACTION_CURRENCY = 'AVERAGE_TRANSACTION_CURRENCY';

export const REFUNDS = 'REFUNDS';

export const REQ_LIFETIME_GMV_FOR_RISKSHIELD = 25000;

export const GST_FORM_SURVEY_URL = 'https://forms.gle/QVyya3PoAHjCFbaw6';

export const TOKEN_VAULT_BLOG_URL = 'https://blog.cashfree.com/token-vault/';

export const ADVANCES_URL =
  'https://cashfreepayments.typeform.com/advances?utm_source=mdash&utm_campaign=p2tar#mid={mid}';

export const HOLI_OFFER_URL =
  'https://cashfreepayments.freshdesk.com/a/solutions/categories/48000339629/folders/48000684458?view=all&utm_source=dashboard&utm_medium=-&utm_campaign=-&utm_id=mobikwik';

export const VIDEO_EMBED = {
  title: 'Know more about new way to view Standard and Instant Settlements',
  url:
    'https://drive.google.com/file/d/1yduIdf-NWgB1FrC0q-WzNZP67sfAHrwv/preview',
};

export const ACTION_REQUIRED = 'ACTION_REQUIRED';

export const TOKEN_VAULT_ALERT_MIDS = [
  10990,
  875,
  48428,
  2887,
  77091,
  106521,
  46643,
  165926,
  131504,
  188521,
  4647,
  45455,
  75555,
  92563,
  70785,
  174677,
  105923,
  15315,
  70251,
  165313,
  39554,
  166964,
  103607,
  13847,
  135627,
  90818,
  167050,
  194118,
  98196,
  38251,
  178141,
  41429,
  69521,
  183535,
  29534,
  186050,
  162,
  135915,
  159095,
  38199,
  132219,
  104345,
  176044,
  83594,
  141383,
  14776,
  72061,
  132227,
  89463,
  170529,
  137083,
  55127,
  122376,
  2739,
  46342,
  165859,
  133870,
  47642,
  107795,
  136439,
  50792,
  96098,
  96451,
  88139,
  157185,
  196867,
  159572,
  98804,
  187325,
  185082,
  160537,
  190479,
  181837,
  151070,
  198974,
  193202,
  73578,
  135604,
  102680,
  200776,
  183491,
  141881,
  190872,
  155347,
  90327,
  637,
  118242,
  95771,
  130372,
  159507,
  113694,
  143844,
  156589,
  185259,
  176065,
  211191,
  33303,
  161921,
  120121,
  166248,
  193274,
  75874,
  122154,
  120545,
  85533,
  190986,
  2982,
  187092,
  1712,
  160751,
  185840,
  100261,
  169145,
  196579,
  171718,
  158007,
  26138,
  129224,
  182244,
  289,
  185914,
  158199,
  120526,
  128598,
  87166,
  147296,
  174355,
  63984,
  186365,
  131701,
  201606,
  139802,
  183615,
  81945,
  203302,
  160744,
  129683,
  128845,
  165615,
  114177,
  132702,
  105845,
  27972,
  200020,
  191686,
  173158,
  145936,
  215699,
  157328,
  142400,
  163875,
  77307,
  170180,
  151359,
  180710,
  193960,
  94681,
  14323,
  161193,
  158836,
  155625,
  88141,
  180499,
  169596,
  73510,
  96855,
  187749,
  38158,
  12350,
  133943,
  161090,
  204873,
  73528,
  136352,
  33875,
  186750,
  115160,
  157078,
  170906,
  140905,
  173604,
  39786,
  78822,
  98996,
  158042,
  3462,
  161553,
  168146,
  13445,
  162432,
  190625,
  164064,
  73238,
  152453,
  8769,
  174286,
  150032,
  111044,
  32175,
  111448,
  26111,
  190138,
  150022,
  166988,
  57725,
  12700,
  186289,
  159578,
  126362,
  77505,
  54576,
  201429,
  155348,
  1170,
  69792,
  182035,
  1628,
  186649,
  119990,
  54553,
  48293,
  138235,
  4014,
  214414,
  76676,
  209748,
  50248,
  169591,
  167617,
  169488,
  150065,
  93757,
  112039,
  29774,
  99337,
  81958,
  87006,
  207251,
  152062,
  201012,
  167610,
  129507,
  205909,
  195681,
  165269,
  13699,
  36358,
  183950,
  154031,
  138546,
  13274,
  204554,
  107173,
  88142,
  190916,
  169615,
  189231,
  147352,
  23849,
  110750,
  164124,
  88132,
  188036,
  164065,
  211563,
  190655,
  81802,
  130510,
  12619,
  61443,
  76362,
  91669,
  186733,
  84185,
  158893,
  179507,
  79752,
  78727,
  159279,
  197349,
  148720,
  3070,
  153385,
  217063,
  204564,
  130961,
  171907,
  200001,
  3440,
  11035,
  155044,
  129258,
  98922,
  124682,
  178821,
  33213,
  203801,
  171538,
  153994,
  50842,
  103489,
  37840,
  110775,
  200382,
  185585,
  148997,
  197307,
  125179,
  75919,
  12348,
  110264,
  158039,
  169900,
  203119,
  191978,
  132594,
  96810,
  32936,
  199148,
  83373,
  153275,
  171655,
  165731,
  192810,
  179501,
  206924,
  207809,
  152999,
  90191,
  46395,
  153678,
  162723,
  203102,
  217181,
  69789,
  32181,
  153637,
  163885,
  48453,
  114087,
  167266,
  167017,
  185187,
  169874,
  45646,
  216859,
  127803,
  544,
  181333,
  197291,
  146169,
  175036,
  178766,
  149117,
  202661,
  91420,
  97303,
  150491,
  120369,
  196936,
  159556,
  2018,
  191703,
  8430,
  97639,
  197943,
  140439,
  163282,
  203167,
  166292,
  189270,
  160670,
  144735,
  119788,
  36703,
  125244,
  94864,
  118401,
  126621,
  142875,
  150577,
  217165,
  115217,
  179282,
  162333,
  81954,
  89475,
  189156,
  117099,
  190601,
  190596,
  156344,
  207702,
  190579,
  143866,
  213030,
  37136,
  149733,
  120116,
  122428,
  213491,
  163817,
  189562,
  100635,
  149583,
  96081,
  99243,
  178438,
  187601,
  181719,
  150448,
  96479,
  171972,
  124580,
  217191,
  188123,
  186662,
  84070,
  87266,
  78657,
  157057,
  98584,
  180915,
  122016,
  112043,
  115669,
  26364,
  123071,
  38954,
  102748,
  167746,
  115359,
  180828,
  110879,
  32694,
  109368,
  172605,
  80941,
  205531,
  181757,
  164299,
  170212,
  201047,
  176050,
  129960,
  150018,
  148593,
  157058,
  214017,
  189167,
  185603,
  136627,
  194416,
  189052,
  1258,
  139404,
  203768,
  171705,
  2332,
  170228,
  131659,
  87155,
  150766,
  200315,
  202718,
  92953,
  191667,
  119049,
  169955,
  189161,
  95629,
  189173,
  70330,
  161636,
  190864,
  88145,
  80660,
  197942,
  66056,
  142693,
  179141,
  127061,
  201442,
  150069,
  198225,
  170302,
  150769,
  186966,
  173669,
  200108,
  176923,
  127611,
  71935,
  153463,
  171643,
  191025,
  106560,
  80528,
  187580,
  123458,
  166421,
  153225,
  101930,
  137297,
  165113,
  147359,
  144916,
  117100,
  161083,
  112268,
  1162,
  211613,
  110979,
  137358,
  130908,
  194045,
  108115,
  98586,
  73691,
  3994,
  160026,
  172271,
  102117,
  114227,
  161579,
  187938,
  201413,
  143806,
  178299,
  3627,
  190497,
  183920,
  66618,
  51582,
  212567,
  164168,
  173924,
  175031,
  185799,
  191009,
  102204,
  141132,
  203258,
  72939,
  89623,
  110844,
  180937,
  173908,
  127582,
  59002,
  133,
  105575,
  176388,
  137811,
  66544,
  13224,
  137146,
  188105,
  177294,
  196211,
  150796,
  76325,
  199507,
  196946,
  215826,
  150417,
  107724,
  125682,
  174025,
  169717,
  188131,
  91662,
  112151,
  76498,
  185204,
  23934,
  142031,
  113564,
  361,
  185901,
  163887,
  68690,
  158483,
  178780,
  172076,
  5152,
  72852,
  39975,
  8775,
  196872,
  197926,
  159939,
  89494,
  82120,
  40225,
  181304,
  143877,
  200665,
  71930,
  172060,
  160578,
  213853,
  98777,
  171935,
  113637,
  185591,
  74021,
  204128,
  187603,
  217174,
  144782,
  182123,
  166335,
  72168,
  15178,
  487,
  23931,
  58697,
  135924,
  172025,
  141574,
  144624,
  156193,
  214396,
  183290,
  170214,
  152204,
  60466,
  142536,
  115954,
  160308,
  177427,
  103118,
  49666,
  2543,
  135383,
  204756,
  39357,
  168045,
  212839,
  205474,
  152210,
  195357,
  107960,
  171547,
  158903,
  71931,
  143234,
  162124,
  44583,
  142029,
  172062,
  144829,
  100427,
  172988,
  135760,
  94158,
  198898,
  205306,
  201091,
  146466,
  85046,
  187050,
  185205,
  147318,
  74114,
  4287,
  160408,
  210564,
  100574,
  88136,
  197874,
  37293,
  8005,
  34013,
  138544,
  191662,
  195578,
  116273,
  88713,
  114919,
  212948,
  54611,
  113902,
  63288,
  210435,
  149081,
  43700,
  143821,
  181307,
  161692,
  170400,
  140167,
  188328,
  139676,
  198182,
  163546,
  120474,
  204126,
  179524,
  179594,
  160285,
  202478,
  143050,
  162761,
  5674,
  202498,
  874,
  25684,
  14990,
  80504,
  189990,
  88356,
  136665,
  60960,
  198126,
  102050,
  153159,
  73797,
  88809,
  192854,
  184657,
  76329,
  105851,
  1401,
  130674,
  135133,
  161577,
  102631,
  128379,
  204608,
  84273,
  151615,
  106620,
  210645,
  132204,
  67920,
  153073,
  167039,
  42891,
  202504,
  9878,
  143495,
  203059,
  146549,
  210696,
  139516,
  155609,
  150053,
  4113,
  113630,
  77445,
  150453,
  91021,
  135578,
  173941,
  105352,
  6125,
  170514,
  102981,
  201742,
  188889,
  148921,
  71937,
  143126,
  146728,
  140300,
  196555,
  145019,
  189254,
  25791,
  151974,
  123005,
  181673,
  53008,
  71933,
  128034,
  123200,
  204904,
  139874,
  49176,
  142032,
  149496,
  160255,
  100690,
  71170,
  179670,
  186410,
  54093,
  76337,
  207338,
  76342,
  125016,
  192416,
  185137,
  63285,
  92558,
  5537,
  182344,
  137908,
  143798,
  118045,
  123251,
  148889,
  178749,
  206566,
  172335,
  155293,
  22988,
  104162,
  190190,
  205842,
  160899,
  140935,
  160065,
  135389,
  207922,
  186043,
  94310,
  120926,
  131977,
  176311,
  83687,
  94018,
  190115,
  144612,
  151078,
  3820,
  115908,
  127331,
  183144,
  182236,
  210714,
  69417,
  77288,
  143020,
  178088,
  172340,
  107677,
  140456,
  205636,
  183851,
  76348,
  177697,
  198808,
  133912,
  102237,
  163734,
  40915,
  58874,
  143826,
  209180,
  181974,
  193235,
  63977,
  78598,
  154655,
  195158,
  167523,
  3353,
  175181,
  130173,
  188074,
  25667,
  179617,
  143846,
  207627,
  167739,
  131051,
  204687,
  204604,
  132251,
  115492,
  145901,
  160008,
  100658,
  89586,
  181575,
  202452,
  128970,
  149340,
  207226,
  208433,
  39561,
  142033,
  4438,
  161818,
  170977,
  152125,
  177240,
  14373,
  183157,
  122740,
  204584,
  160483,
  185232,
  60375,
  120767,
  132685,
  184355,
  151520,
  161812,
  86838,
  163442,
  179618,
  82998,
  92779,
  67324,
  79937,
  186373,
  199579,
  95902,
  191007,
  176588,
  143782,
  180917,
  152688,
  150259,
  163311,
  122277,
  154045,
  97102,
  190949,
  166294,
  203448,
  141784,
  101418,
  193947,
  129415,
  198315,
  171628,
  142826,
  105844,
  52069,
  207488,
  74629,
  73931,
  64762,
  126163,
  164020,
  26457,
  143842,
  187416,
  193766,
  2580,
  105486,
  102851,
  121542,
  152541,
  207167,
  165755,
  106817,
  160234,
  143191,
  91123,
  113676,
  95141,
  137375,
  160526,
  1848,
  185533,
  124209,
  143872,
  51592,
  170978,
  162106,
  102106,
  179927,
  56525,
  203888,
  210229,
  197970,
  36603,
  212474,
  173877,
  161081,
  198211,
  150775,
  165094,
  154890,
  158062,
  170958,
  128842,
  133959,
  195396,
  204712,
  198147,
  67008,
  168147,
  181927,
  207654,
  203513,
  96905,
  165602,
  203904,
  177009,
  147818,
  204922,
  150527,
  65390,
  184212,
  128199,
  145548,
  199024,
  191988,
  8411,
  185910,
  172455,
  106378,
  175164,
  169847,
  170004,
  40761,
  144037,
  66067,
  155940,
  152143,
  86639,
  137644,
  179223,
  152662,
  186798,
  133472,
  187098,
  160343,
  72244,
  113951,
  52761,
  200710,
  161872,
  164841,
  108282,
  129046,
  117615,
  118731,
  15352,
  105795,
  194009,
  137547,
  128029,
  190074,
  76335,
  163843,
  152483,
  74821,
  137546,
  37197,
  183204,
  187710,
  190495,
  72717,
  83009,
  102565,
  135787,
  156370,
  2832,
  58266,
  33153,
  126831,
  126199,
  144478,
  9090,
  194603,
  158206,
  161041,
  168823,
  133285,
  173064,
  67746,
  75290,
  75079,
  203910,
  139888,
  352,
  211077,
  92213,
  181299,
  165445,
  131585,
  183007,
  178834,
  68390,
  188337,
  120327,
  200513,
  142744,
  134565,
  175120,
  190499,
  124198,
  503,
  90663,
  140037,
  70256,
  187642,
  208462,
  186690,
  154142,
  182852,
  135997,
  126074,
  186367,
  154027,
  134939,
  206847,
  196993,
  140940,
  153284,
  49865,
  188759,
  162657,
  206852,
  138185,
  139597,
  189083,
  151883,
  116441,
  183756,
  165142,
  151518,
  188918,
  150572,
  182567,
  150058,
  165999,
  150059,
  99275,
  109131,
  99167,
  154737,
  204916,
  27636,
  199159,
  196530,
  202500,
  181361,
  69374,
  164381,
  160263,
  179310,
  176892,
  150260,
  178682,
  136553,
  203555,
  179572,
  67080,
  150073,
  158158,
  180615,
  171148,
  136027,
  140346,
  146036,
  201427,
  162932,
  105135,
  139569,
  142458,
  3617,
  181352,
  141963,
  178630,
  68395,
  142654,
  140487,
  153421,
  139717,
  164588,
  187578,
  90579,
  183556,
  84105,
  143446,
  181945,
  114102,
  171555,
  161825,
  204315,
  23408,
  180856,
  172406,
  167186,
  206866,
  48362,
  60034,
  176786,
  140221,
  164672,
  214300,
  190484,
  152996,
  164452,
  141964,
  161581,
  186282,
  186325,
  171701,
  162749,
  74768,
  126999,
  73267,
  143791,
  25682,
  156304,
  157967,
  205179,
  174354,
  150530,
  31899,
  128320,
  74968,
  105539,
  185340,
  108371,
  151216,
  122078,
  148438,
  193120,
  209313,
  202723,
  15141,
  129158,
  179174,
  196988,
  39550,
  153432,
  164199,
  145397,
  34003,
  3006,
  198863,
  67041,
  192841,
  67232,
  66612,
  160198,
  110254,
  51351,
  146713,
  165253,
  158668,
  31357,
  150558,
  149095,
  86139,
  190884,
  143862,
  178459,
  39484,
  82341,
  54056,
  202900,
  156573,
  178573,
  103045,
  110766,
  54815,
  200215,
  70473,
  207792,
  185650,
  51385,
  7441,
  209847,
  84394,
  138523,
  94813,
  104757,
  160956,
  205428,
  180297,
  169074,
  185174,
  141987,
  65729,
  149320,
  147089,
  150249,
  201636,
  123983,
  115620,
  161561,
  157079,
  93002,
  172549,
  207684,
  144799,
  69083,
  188261,
  138434,
  216463,
  127573,
  169073,
  174566,
  141977,
  114159,
  139933,
  185865,
  116416,
  207084,
  157758,
  57665,
  42496,
  155059,
  141581,
  183131,
  173609,
  186382,
  152491,
  139142,
  126427,
  143746,
  172358,
  136885,
  173276,
  160342,
  115017,
  54469,
  64693,
  172343,
  186198,
  159354,
  187100,
  158826,
  206084,
  43421,
  139356,
  150502,
  207560,
  9451,
  178850,
  159355,
  145730,
  165399,
  179682,
  169129,
  160520,
  180478,
  185526,
  146658,
  104065,
  49358,
  200114,
  24264,
  198259,
  168713,
  207570,
  207707,
  73269,
  158498,
  126871,
  139344,
  66651,
  101955,
  132520,
  121459,
  78345,
  169851,
  185289,
  163422,
  143515,
  133606,
  192692,
  213898,
  152624,
  27096,
  28967,
  147113,
  198222,
  152405,
  201182,
  104376,
  9888,
  184838,
  200297,
  128682,
  143144,
  158904,
  88079,
  213316,
  88866,
  149547,
  158311,
  122023,
  147312,
  174327,
  156645,
  164339,
  102379,
  141984,
  187097,
  113889,
  139308,
  173579,
  210437,
  214313,
  169219,
  185351,
  187782,
  160333,
  185596,
  13790,
  44841,
  157808,
  4429,
  40851,
  125367,
  169954,
  59739,
  164641,
  152223,
  175390,
  184215,
  141853,
  188760,
  70921,
  93282,
  204521,
  58493,
  140407,
  195610,
  165998,
  200871,
  80795,
  133513,
  149247,
  158837,
  187122,
  200455,
  106512,
  205663,
  99754,
  161837,
  160699,
  48499,
  165118,
  144548,
  159107,
  158607,
  43449,
  61805,
  41334,
  185556,
  139872,
  183555,
  98613,
  156328,
  169581,
  190907,
  83874,
  24673,
  78276,
  33930,
  200701,
  191469,
  199463,
  96217,
  142752,
  38490,
  199631,
  124492,
  148291,
  191386,
  165789,
  185345,
  71158,
  118273,
  141958,
  189819,
  179586,
  7682,
  157586,
  211008,
  166012,
  175372,
  734,
  165357,
  138186,
  143066,
  205910,
  106951,
  126456,
  152407,
  188119,
  187145,
  113967,
  193938,
  139558,
  143443,
  195408,
  157611,
  189268,
  80658,
  24479,
  161010,
  190648,
  137301,
  190599,
  128150,
  175186,
  169117,
  47014,
  179503,
  86360,
  92369,
  214352,
  146995,
  175417,
  134220,
  190314,
  2682,
  212938,
  212015,
  76894,
  126240,
  175045,
  182187,
  209711,
  95248,
  142030,
  100858,
  114109,
  156987,
  177345,
  180636,
  122772,
  193500,
  196611,
  192878,
  129062,
  109705,
  136493,
  173567,
  165279,
  188498,
  162239,
  159458,
  205840,
  186772,
  58904,
  188188,
  175118,
  34853,
  118486,
  191613,
  181186,
  192943,
  203152,
  170556,
  98508,
  185213,
  98770,
  147161,
  197491,
  163322,
  25685,
  159515,
  145357,
  100451,
  199201,
  52056,
  141961,
  155924,
  141967,
  141970,
  141982,
  203892,
  156777,
  172005,
  156289,
  132399,
  169470,
  189068,
  190189,
  163982,
  194738,
  167113,
  193503,
  99903,
  149007,
  141985,
  214299,
  66062,
  190470,
  73723,
  193942,
  28473,
  122609,
  179186,
  108881,
  145114,
  181843,
  90766,
  146136,
  157782,
  196489,
  68406,
  166006,
  148673,
  191537,
  38051,
  213670,
  104523,
  172018,
  141983,
  136209,
  186019,
  50652,
  183554,
  143042,
  165956,
  202333,
  212191,
  204606,
  67258,
  141962,
  61503,
  116990,
  115583,
  191976,
  201218,
  151560,
  178539,
  196507,
  187501,
  166187,
  76600,
  86362,
  141993,
  166008,
  123399,
  171712,
  186128,
  64141,
  159561,
  119099,
  193841,
  59755,
  171977,
  32180,
  198514,
  190177,
  14245,
  179613,
  162603,
  186266,
  79042,
  135962,
  196287,
  175901,
  190684,
  136421,
  25747,
  81793,
  105855,
  167302,
  63909,
  83014,
  176279,
  178225,
  192919,
  166856,
  182553,
  164419,
  139523,
  25251,
  207836,
  151826,
  169252,
  144905,
  23589,
  90632,
  115856,
  194346,
  75200,
  113401,
  183917,
  89153,
  149507,
  195273,
  47922,
  186752,
  133260,
  140627,
  160941,
  154704,
  196869,
  159332,
  175401,
  24079,
  182914,
  138396,
  182357,
  160336,
  1745,
  172462,
  73966,
  185571,
  90320,
  121869,
  141999,
  79551,
  171503,
  201210,
  187414,
  153671,
  142026,
  148139,
  158535,
  200636,
  141965,
  146016,
  174065,
  116539,
  98836,
  160539,
  153498,
  148610,
  151871,
  203411,
  161518,
  68368,
  197865,
  77316,
  179199,
  121442,
  200845,
  207417,
  181409,
  41695,
  167043,
  157142,
  159575,
  91127,
  31295,
  65073,
  171603,
  212356,
  15109,
  131162,
  144975,
  207493,
  184296,
  190452,
  33977,
  83036,
  192864,
  157597,
  211578,
  120725,
  1793,
  209371,
  126159,
  87115,
  51460,
  126930,
  55012,
  211839,
  189543,
  209828,
  197052,
  203296,
  205900,
  24097,
  105941,
  51410,
  68960,
  157464,
  141974,
  172412,
  159339,
  179766,
  164946,
  113531,
  184276,
  165665,
  160970,
  190530,
  148046,
  173573,
  154698,
  214529,
  126878,
  65479,
  174300,
  3628,
  175119,
  162428,
  160120,
  201794,
  152403,
  191646,
  68382,
  114697,
  207485,
  139934,
  82316,
  185202,
  74734,
  145008,
  45194,
  146987,
  126462,
  109468,
  138428,
  107543,
  162873,
  198251,
  33517,
  110885,
  88594,
  133815,
  191156,
  159123,
  211618,
  14640,
  159327,
  198882,
  25192,
  111878,
  176328,
  146524,
  186981,
  93356,
  192884,
  68219,
  150635,
  152218,
  58620,
  182126,
  184524,
  195249,
  188332,
  115022,
  136809,
  82007,
  141981,
  159699,
  151298,
  191075,
  141990,
  186721,
  191068,
  11933,
  120713,
  81996,
  603,
  141997,
  172940,
  196898,
  205798,
  136622,
  157365,
  167623,
  100670,
  204625,
  105961,
  159111,
  181632,
  196480,
  14508,
  140032,
  193517,
  126485,
  180643,
  168510,
  141959,
  151392,
  157562,
  129394,
  184089,
  124421,
  6728,
  180637,
  141916,
  39961,
  193194,
  186143,
  169139,
  192627,
  192678,
  160382,
  137133,
  192866,
  209846,
  23244,
  190478,
  161523,
  187598,
  161964,
  152464,
  77805,
  195315,
  203851,
  130796,
  195670,
  203828,
  197888,
  119766,
  37275,
  173594,
  206946,
  68374,
  141966,
  171946,
  196596,
  145488,
  130193,
  182751,
  97299,
  141976,
  155608,
  76234,
  205166,
  99072,
  193081,
  178200,
  169906,
  171936,
  35823,
  44111,
  197871,
  157128,
  175929,
  78711,
  151479,
  145400,
  45283,
  55229,
  66794,
  91878,
  201204,
  141988,
  123449,
  131130,
  195770,
  192658,
  98773,
  192886,
  184938,
  51466,
  57353,
  208546,
  134330,
  154258,
  191093,
  176913,
  110737,
  111858,
  163938,
  192893,
  85952,
  193951,
  59198,
  202687,
  114488,
  28281,
  180470,
  134178,
  173212,
  152084,
  124525,
  185888,
  53593,
  158570,
  87668,
  198217,
  196803,
  174776,
  66786,
  172366,
  13932,
  142712,
  199840,
  166085,
  184362,
  216476,
  156969,
  168962,
  167004,
  190869,
  166323,
  114948,
  182307,
  191264,
  182495,
  180547,
  105811,
  11769,
  163251,
  41112,
  192902,
  197068,
  190896,
  159056,
  119679,
  141989,
  172365,
  202587,
  159135,
  117360,
  135677,
  154896,
  109246,
  167331,
  156523,
  192879,
  143734,
  182050,
  122894,
  184471,
  171642,
  194172,
  135659,
  187626,
  196234,
  127923,
  169593,
  119331,
  161758,
  72335,
  173880,
  9412,
  198253,
  142431,
  193981,
  141986,
  143086,
  31814,
  162048,
  27577,
  178551,
  210763,
  132936,
  167559,
  146400,
  148875,
  136773,
  183359,
  173899,
  61316,
  4117,
  192945,
  165452,
  23443,
  79246,
  144588,
  141996,
  81567,
  128446,
  192885,
  180774,
  110225,
  182637,
  199153,
  120785,
  169124,
  164532,
  180650,
  77105,
  216423,
  154325,
  98603,
  141979,
  175081,
  4255,
  169381,
  164839,
  161847,
  144327,
  203533,
  171917,
  105975,
  163452,
  122128,
  4539,
  173728,
  167130,
  156703,
  120342,
  45286,
  213933,
  98025,
  145904,
  113576,
  151873,
  199285,
  34233,
  143819,
  141995,
  200768,
  146587,
  194124,
  185872,
  78849,
  162255,
  44173,
  102196,
  125025,
  192915,
  171517,
  154039,
  2250,
  216789,
  191898,
  204891,
  185504,
  56989,
  202446,
  130927,
  120702,
  142303,
  8822,
  210214,
  131828,
  156082,
  179510,
  148717,
  151726,
  170392,
  191656,
  188741,
  215788,
  102805,
  163657,
  190691,
  160323,
  207093,
  184387,
  93485,
  209228,
  200002,
  177049,
  188005,
  137074,
  116745,
  117476,
  170722,
  200991,
  198227,
  124695,
  11276,
  190107,
  200674,
  139549,
  40963,
  195913,
  174686,
  209184,
  208620,
  190276,
  163848,
  186723,
  132920,
  175192,
  136824,
  151968,
  192220,
  182220,
  153705,
  141998,
  174405,
  188039,
  124510,
  211293,
  156595,
  84193,
  192932,
  184651,
  149268,
  178170,
  160072,
  57351,
  189205,
  109885,
  115386,
  85696,
  200637,
  187063,
  189552,
  160796,
  195026,
  150677,
  168913,
  183358,
  200398,
  143663,
  52613,
  152249,
  161654,
  188282,
  200481,
  197911,
  196659,
  192883,
  106308,
  186984,
  155159,
  198837,
  96756,
  142811,
  213831,
  75342,
  177361,
  196115,
  154465,
  188921,
  217858,
  161760,
  12656,
  197980,
  36268,
  84011,
  136065,
  96191,
  205569,
  110847,
  175434,
  65061,
  102298,
  89383,
  15318,
  197054,
  133225,
  144611,
  172643,
  187780,
  178614,
  204531,
  130210,
  80848,
  152082,
  59746,
  190972,
  122967,
  12950,
  140001,
  151678,
  85211,
  142451,
  107717,
  142425,
  144883,
  92406,
  207128,
  170574,
  72313,
  175193,
  45284,
  98832,
  202882,
  3587,
  106070,
  130667,
  158404,
  150379,
  107602,
  161595,
  89648,
  157886,
  192859,
  30814,
  150406,
  192888,
  24789,
  146183,
  192880,
  161822,
  82006,
  125342,
  217638,
  205498,
  70348,
  183675,
  91785,
  195208,
  62018,
  212380,
  96048,
  117924,
  59752,
  183233,
  191290,
  160366,
  172611,
  196618,
  103421,
  204846,
  122878,
  174443,
  180625,
  100997,
  151451,
  200126,
  196947,
  14655,
  120778,
  123357,
  97822,
  178213,
  206788,
  114647,
  137224,
  196119,
  206619,
  186290,
  150673,
  102145,
  134280,
  109650,
  173676,
  206708,
  146548,
  192015,
  190192,
  207230,
  177061,
  171767,
  51472,
  107907,
  51424,
  203104,
  167676,
  126231,
  141994,
  8247,
  105769,
  84215,
  175941,
  100175,
  122157,
  170940,
  78110,
  107323,
  216644,
  47899,
  160921,
  192857,
  192865,
  175141,
  86504,
  131916,
  156606,
  85879,
  163329,
  966,
  150909,
  165777,
  15009,
  179131,
  105797,
  152822,
  65053,
  161663,
  152601,
  176419,
  175997,
  150457,
  176356,
  166009,
  59261,
  201117,
  51364,
  175011,
  181895,
  160110,
  161754,
  167723,
  199852,
  84318,
  192946,
  197003,
  123582,
  209400,
  182233,
  102139,
  147016,
  110805,
  195644,
  171954,
  147803,
  194911,
  158554,
  206846,
  172002,
  167298,
  173663,
  207879,
  59890,
  129927,
  142373,
  64242,
  210219,
  170596,
  116739,
  145138,
  193096,
  127603,
  161549,
  70257,
  130201,
  63866,
  167115,
  195758,
  43631,
  149042,
  192828,
  102663,
  194352,
  178810,
  164502,
  182657,
  136991,
  135763,
  168066,
  187733,
  168703,
  129610,
  182371,
  162317,
  202641,
  115363,
  188749,
  152252,
  110724,
  215880,
  187815,
  121656,
  160579,
  190564,
  125626,
  51386,
  139822,
  163659,
  190575,
  146660,
  196127,
  99855,
  169147,
  157604,
  154689,
  188862,
  70433,
  195786,
  183819,
  152205,
  143658,
  165274,
  147409,
  153186,
  147032,
  60456,
  195278,
  93202,
  165652,
  183147,
  207580,
  205050,
  147663,
  185578,
  198576,
  102632,
  189067,
  112459,
  96850,
  178876,
  149773,
  43052,
  181960,
  62908,
  201312,
  169460,
  148686,
  167297,
  160541,
  192875,
  72005,
  178915,
  90643,
  93578,
  196999,
  84813,
  115568,
  190051,
  96255,
  175516,
  181495,
  150052,
  105932,
  191292,
  211492,
  215890,
  175090,
  208260,
  137233,
  70326,
  154856,
  82001,
  173635,
  356,
  68348,
  12674,
  113964,
  198330,
  121669,
  187523,
  151932,
  97676,
  162244,
  192892,
  141436,
  168730,
  170176,
  183683,
  151467,
  155985,
  79391,
  133033,
  87272,
  157376,
  124830,
  217032,
  153307,
  146081,
  131756,
  159690,
  64166,
  71928,
  217166,
  138827,
  204490,
  198252,
  152206,
  159121,
  141968,
  35282,
  185389,
  198664,
  166245,
  42131,
  174746,
  141472,
  135173,
  128089,
  139396,
  160557,
  200353,
  109514,
  181369,
  168211,
  74934,
  144385,
  179119,
  179709,
  103485,
  95108,
  136024,
  204610,
  66772,
  169121,
  119232,
  126490,
  164473,
  26917,
  132606,
  130056,
  169220,
  197370,
  152091,
  100440,
  162122,
  183253,
  156578,
  186707,
  204910,
  11831,
  139915,
  143928,
  192863,
  181520,
  93949,
  169467,
  87183,
  153454,
  189708,
  155244,
  156989,
  194403,
  197698,
  26797,
  180464,
  198551,
  138264,
  204176,
  192890,
  207355,
  183614,
  83218,
  174715,
  95948,
  60629,
  192887,
  191628,
  169669,
  76294,
  198852,
  82004,
  206741,
  179106,
  159020,
  163856,
  84468,
  160100,
  1567,
  198241,
  156625,
  93407,
  87494,
  144187,
  93320,
  157295,
  84223,
  160269,
  146251,
  111187,
  214869,
  171084,
  197329,
  192939,
  158781,
  69905,
  190065,
  190320,
  163993,
  57166,
  171924,
  81223,
  97648,
  188874,
  169975,
  160552,
  196858,
  166007,
  152522,
  125503,
  149242,
  173681,
  64600,
  198949,
  57234,
  185534,
  144699,
  49688,
  189190,
  127362,
  184811,
  203396,
  167317,
  140400,
  183365,
  130936,
  153082,
  122442,
  94307,
  57979,
  186073,
  72318,
  1063,
  178791,
  186387,
  149718,
  10507,
  174802,
  81990,
  189727,
  169933,
  152081,
  4099,
  201016,
  145450,
  151860,
  170235,
  193473,
  156318,
  112623,
  68480,
  13696,
  207706,
  186525,
  214860,
  198523,
  114548,
  38009,
  174787,
  76563,
  128031,
  196899,
  179502,
  81999,
  157778,
  165339,
  32823,
  155718,
  28189,
  97219,
  155707,
  3185,
  191226,
  185234,
  156071,
  215068,
  201717,
  169555,
  160229,
  187771,
  203565,
  203154,
  65059,
  110575,
  156942,
  181989,
  163132,
  162441,
  155740,
  120549,
  140563,
  167123,
  138766,
  214236,
  166000,
  161398,
  185342,
  154467,
  157791,
  77226,
  157291,
  75655,
  204993,
  179968,
  88088,
  207589,
  163901,
  166265,
  168415,
  193455,
  167268,
  110121,
  216400,
  175183,
  172566,
  178901,
  32240,
  100339,
  186399,
  183840,
  204597,
  151088,
  172724,
  101848,
  180928,
  134201,
  26368,
  161839,
  205282,
  163865,
  151647,
  184302,
  203617,
  150037,
  212350,
  172456,
  200749,
  955,
  151081,
  198052,
  97180,
  210277,
  171523,
  185575,
  170985,
  197873,
  124110,
  214316,
  190730,
  139350,
  150828,
  140777,
  204662,
  200237,
  138587,
  75713,
  85585,
  75306,
  100552,
  169170,
  159039,
  105558,
  215922,
  196827,
  85458,
  120096,
  58681,
  59743,
  190087,
  11177,
  26395,
  186092,
  59758,
  143808,
  30906,
  116743,
  128734,
  180959,
  203493,
  201865,
  202836,
  163348,
  191719,
  204757,
  161533,
  192762,
  108891,
  165898,
  164467,
  199970,
  198232,
  202643,
  151928,
  159286,
  143297,
  135957,
  150097,
  127804,
  169203,
  153841,
  71536,
  206784,
  208969,
  176149,
  129151,
  152796,
  85759,
  205267,
  125024,
  166027,
  120913,
  36618,
  82551,
  44628,
  188674,
  138719,
  150689,
  128967,
  129106,
  199073,
  41568,
  198562,
  112342,
  98259,
  75001,
  80603,
  178482,
  170840,
  176201,
  191190,
  156169,
  151038,
  173592,
  129000,
  212834,
  77629,
  171497,
  157141,
  193229,
  66343,
  190591,
  36931,
  163866,
  74936,
  192792,
  66853,
  196918,
  185370,
  138664,
  147423,
  91978,
  188432,
  200123,
  153585,
  169396,
  59146,
  174658,
  140954,
  170964,
  119634,
  204455,
  85648,
  154706,
  112703,
  188138,
  216451,
  190508,
  38947,
  216993,
  64701,
  93329,
  191299,
  166994,
  164464,
  114551,
  105897,
  59759,
  177589,
  145623,
  161689,
  176953,
  119829,
  148818,
  191223,
  172089,
  177195,
  72231,
  167640,
  211309,
  51427,
  205288,
  181671,
  195833,
  190570,
  182033,
  162537,
  59761,
  192816,
  109393,
  76173,
  201600,
  100909,
  204302,
  167609,
  196891,
  114935,
  206934,
  153201,
  110493,
  193527,
  34008,
  68414,
  153609,
  196748,
  163896,
  62693,
  114356,
  130320,
  178963,
  190296,
  169564,
  196655,
  141388,
  160825,
  165251,
  193748,
  168416,
  192882,
  162680,
  210256,
  208259,
  171682,
  192636,
  178898,
  72746,
  34074,
  315,
  41344,
  4139,
  125195,
  95373,
  147666,
  168468,
  9357,
  135633,
  26207,
  79344,
  23824,
  157146,
  165655,
  193591,
  177688,
  196671,
  205171,
  119332,
  172967,
  95475,
  144579,
  214593,
  190998,
  56679,
  67291,
  174305,
  13402,
  196125,
  163640,
  203400,
  185325,
  208108,
  142000,
  214358,
  82100,
  202505,
  168057,
  198226,
  189130,
  98391,
  131642,
  163382,
  187595,
  152490,
  211133,
  209353,
  48829,
  190412,
  3907,
  183876,
  197223,
  172234,
  1978,
  163886,
  162176,
  129362,
  88154,
  79880,
  87400,
  181300,
  84599,
  188252,
  214366,
  125331,
  210759,
  63010,
  192052,
  196260,
  174285,
  153564,
  160309,
  170677,
  192877,
  95959,
  160917,
  113731,
  195688,
  205114,
  172508,
  196927,
  177367,
  65917,
  147098,
  102057,
  164817,
  213250,
  134409,
  167063,
  164963,
  134045,
  59122,
  30621,
  182921,
  192734,
  181556,
  32,
  199263,
  125361,
  81751,
  86830,
  184435,
  199483,
  191529,
  164084,
  85885,
  169320,
  190837,
  188601,
  65228,
  184300,
  209194,
  187677,
  196937,
  216367,
  160562,
  100231,
  201172,
  179733,
  170972,
  95069,
  81553,
  62630,
  166986,
  172533,
  136883,
  105378,
  167228,
  13825,
  78235,
  160494,
  174316,
  177966,
  110262,
  157362,
  197533,
  199236,
  100168,
  92383,
  100412,
  173565,
  143815,
  183616,
  201619,
  196657,
  159945,
  185356,
  171564,
  215766,
  196526,
  147973,
  158194,
  173587,
  196648,
  173715,
  116502,
  10881,
  160704,
  71835,
  196246,
  132374,
  162919,
  82990,
  124696,
  108083,
  164956,
  81594,
  91590,
  90246,
  188004,
  191258,
  178933,
  207127,
  176013,
  4086,
  178873,
  106743,
  187673,
  116088,
  205596,
  12060,
  144089,
  152507,
  9309,
  13551,
  72498,
  1046,
  165173,
  172070,
  191654,
  103057,
  188540,
  187725,
  146650,
  1294,
  212238,
  186904,
  142159,
  173929,
  163614,
  213270,
  51091,
  187742,
  192894,
  191442,
  191414,
  161055,
  70610,
  212542,
  163913,
  146301,
  46171,
  3141,
  111564,
  107076,
  183190,
  186907,
  195677,
  114143,
  165975,
  175851,
  85744,
  171593,
  153057,
  151877,
  159872,
  183,
  170871,
  52261,
  4806,
  206593,
  178813,
  43197,
  194035,
  37525,
  154695,
  51470,
  180913,
  151817,
  96161,
  2401,
  169884,
  115778,
  206870,
  169386,
  181050,
  171511,
  185523,
  187999,
  184460,
  128452,
  201321,
  189139,
  172407,
  120120,
  163650,
  198491,
  142983,
  139947,
  157329,
  68387,
  200901,
  199283,
  141035,
  168428,
  205488,
  159459,
  191214,
  54620,
  179340,
  146202,
  178195,
  169544,
  174751,
  180590,
  182899,
  23075,
  34735,
  210344,
  188524,
  173961,
  76187,
  135934,
  191705,
  152798,
  186794,
  79393,
  49481,
  88752,
  161712,
  6026,
  100044,
  151054,
  157391,
  216712,
  155864,
  131915,
  178181,
  169178,
  39271,
  183924,
  96869,
  189682,
  205949,
  132689,
  191109,
  154484,
  212506,
  200716,
  198560,
  169395,
  13602,
  133928,
  73996,
  178165,
  180620,
  62695,
  207531,
  198719,
  9360,
  187720,
  159494,
  198526,
  181867,
  164151,
  174339,
  57452,
  147937,
  164202,
  187000,
  167387,
  185824,
  9704,
  72737,
  50410,
  97505,
  173647,
  88409,
  107576,
  12272,
  200076,
  121670,
  173654,
  120825,
  159581,
  192524,
  128529,
  46459,
  201124,
  46923,
  71407,
  137488,
  182685,
  82131,
  34464,
  149560,
  104981,
  88402,
  131274,
  192389,
  189218,
  193781,
  181932,
  190971,
  192158,
  24026,
  150560,
  132451,
  86455,
  197925,
  26335,
  182287,
  210328,
  180877,
  65712,
  216481,
  203150,
  188896,
  174779,
  159539,
  129301,
  200638,
  175695,
  152411,
  168425,
  190288,
  154498,
  165782,
  187990,
  146047,
  192751,
  159108,
  88193,
  68196,
  200540,
  204331,
  116045,
  189893,
  165630,
  200706,
  192647,
  110706,
  164432,
  118523,
  144547,
  99382,
  200030,
  123934,
  1373,
  178906,
  137222,
  52628,
  150472,
  162173,
  178102,
  32172,
  73393,
  174414,
  57241,
  112804,
  164462,
  35362,
  164579,
  156613,
  203115,
  214481,
  156089,
  169379,
  147341,
  162250,
  163893,
  177416,
  185313,
  32679,
  198571,
  73273,
  101665,
  193507,
  205450,
  97692,
  84219,
  143237,
  183198,
  193562,
  202783,
  180612,
  141972,
  163540,
  163611,
  172955,
  176006,
  183900,
  169875,
  9346,
  65182,
  189088,
  192401,
  115911,
  189106,
  160728,
  215451,
  150425,
  98061,
  168494,
  162514,
  195202,
  192688,
  192462,
  98818,
  178912,
  188814,
  176261,
  207834,
  139628,
  49428,
  181277,
  15529,
  75716,
  128829,
  147373,
  186484,
  79392,
  184313,
  79939,
  92389,
  213066,
  198583,
  173602,
  53757,
  114423,
  171495,
  137466,
  141082,
  176010,
  125514,
  31576,
  196726,
  162673,
  192923,
  175521,
  59051,
  174069,
  156602,
  150659,
  192904,
  49274,
  167612,
  196501,
  200352,
  164667,
  173605,
  188505,
  198909,
  35460,
  150,
  167114,
  141643,
  165074,
  186781,
  129160,
  205313,
  193302,
  192944,
  162402,
  150415,
  202149,
  199614,
  172409,
  141975,
  152377,
  191218,
  157473,
  13304,
  119354,
  120703,
  196495,
  73654,
  122140,
  111211,
  194659,
  201131,
  179761,
  25483,
  195181,
  174042,
  84224,
  196483,
  177831,
  213306,
  27838,
  183347,
  196063,
  186372,
  196718,
  120422,
  182431,
  113240,
  189171,
  57631,
  117344,
  200723,
  75529,
  132311,
  216251,
  183156,
  210653,
  59037,
  122095,
  183888,
  181924,
  91985,
];

export const UNDER_REVIEW = 'UNDER_REVIEW';

export const CARD_STATUS = {
  ACTION_REQUIRED: 'Action Required',
  IN_REVIEW: 'Under Review',
};

export const IN_REVIEW = 'IN_REVIEW';

export const SUSPICIOUS_AMOUNT = 'Suspicious Amount';

export const UNSETTLED_AMOUNT = 'UNSETTLED_AMOUNT';

export const UNSETTLED_AMOUNT_MODAL = 'UNSETTLED_AMOUNT_MODAL';

export const PLACEHOLDER_AMOUNT = '0.00';
